import {
  Alert,
  AlertTitle,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ListItemText,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { Box } from "@mui/system";
import { get, post } from "../helpers/request";
import styled from "styled-components";
import { red } from "@mui/material/colors";

const StyledSelect = styled(Select)`
  margin: 0px 16px;
  .MuiSelect-outlined {
    padding: 4px 14px;
  }
`;
const dialogStyle = { "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }
const boxButtonsStyle = { m: 1, position: 'relative' }
const circularProgressStyle = {
  color: red[500],
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginTop: '-12px',
  marginLeft: '-12px',
}
const versionSelectContainerStyle = { '& .MuiTextField-root': { m: 2 } }

const DeployProductionModal = ({ isOpen, onClose, currentSite }) => {
  const [versions, setVersions] = useState([]);
  const [version, setVersion] = useState();
  const [password, setPassword] = useState();
  const [deploying, setDeploying] = useState(false);
  const [error, setError] = useState(false);
  const dispatch = useDispatch();

  const sortedVersions = useMemo(() => {
    if (!versions) return null;
    return versions.sort((a, b) => b.site_version_id - a.site_version_id);
  }, [versions]);

  useEffect(() => {
    if (sortedVersions) setVersion(sortedVersions[0]);
  }, [sortedVersions]);

  useEffect(() => {
    if (isOpen) {
      get(
        `${process.env.REACT_APP_API_URL}/internal/admin/v3/sites/${currentSite?.site_id}/versions`
      ).then((data) => {
        setVersions(data);
      });
    }
  }, [isOpen, currentSite]);

  const handleChangeVersion = useCallback(
    (event) => setVersion(event.target.value),
    []
  );
  const handleChangePassword = useCallback(
    (event) => setPassword(event.target.value),
    []
  );

  const renderName = useCallback(
    (entry) => `Version ${entry.site_version_id} (${entry.created_at})`,
    []
  );

  const handleDeploy = useCallback(() => {
    setDeploying(true);
    setError(false);
    post(
      `${process.env.REACT_APP_API_URL}/internal/admin/v3/sites/deploy/production`,
      {
        site_id: currentSite?.site_id,
        version: version.site_version_id,
        password,
      }
    )
      .then(() => {
        dispatch({
          type: "show-notification",
          content: "Successful deploy!",
          severity: "success",
        });
        onClose();
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setDeploying(false);
      });
  }, [currentSite, version, password, onClose, dispatch]);

  return (
    <Dialog
      sx={dialogStyle}
      maxWidth="xs"
      open={isOpen}
    >
      <DialogTitle>
        Deploy to <b>PRODUCTION</b>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>Select the version to deploy</DialogContentText>
        <Box
          sx={versionSelectContainerStyle}
          noValidate
          autoComplete="off"
        >
          <StyledSelect
            value={version || ""}
            onChange={handleChangeVersion}
            renderValue={renderName}
          >
            {sortedVersions?.map((entry, index) => (
              <MenuItem key={index} value={entry}>
                <ListItemText
                  primary={`Version ${entry.site_version_id} (${entry.created_at})`}
                  secondary={
                    entry.description && entry.description.length > 0
                      ? entry.description
                      : "Sin descripción"
                  }
                />
              </MenuItem>
            ))}
          </StyledSelect>
          <TextField
            label="Password to authorize deploy"
            type="password"
            autoComplete="current-password"
            size="small"
            onChange={handleChangePassword}
          />
        </Box>
        <p>
          Domain:{" "}
          <a
            href={`https://${currentSite?.domain}`}
            target="_blank"
            rel="noreferrer"
          >
            {currentSite?.domain}
          </a>
        </p>
        {error && (
          <Alert severity="error">
            <AlertTitle>Deploy Failed</AlertTitle>
            {error.message}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose}>
          Cancel
        </Button>
        <Box sx={boxButtonsStyle}>
          <Button
            variant="contained"
            color="error"
            onClick={handleDeploy}
            disabled={deploying}
          >
            Deploy
          </Button>
          {deploying && (
            <CircularProgress
              size={24}
              sx={circularProgressStyle}
            />
          )}
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default DeployProductionModal